import { useTheme } from '@mui/material/styles';
import {
  ColorKeyBox,
  ColorKeyBoxes,
  Container,
} from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/ColorKeyPerMatch/styled';
import { COLOR_KEY_DATA } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/ColorKeyPerMatch/utils';

const ColorKeyPerMatch = () => {
  const theme = useTheme();

  return (
    <Container>
      <p>Color key:</p>
      <ColorKeyBoxes>
        {COLOR_KEY_DATA.map(({ label, styles }, idx) => (
          <ColorKeyBox key={`${idx}-${label}`} style={styles(theme)}>
            {label}
          </ColorKeyBox>
        ))}
      </ColorKeyBoxes>
    </Container>
  );
};

export default ColorKeyPerMatch;
